import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetBillingDefaults as GetBillingDefaultsQuery,
    GetBillingDefaults_billingDefaults as BillingDefaults,
} from 'nutshell-graphql-types';

import GET_BILLING_DEFAULTS from '../queries/get-billing-defaults.graphql';

export const useGetBillingDefaults = (
    shouldSkip?: boolean
): {
    billingDefaults: BillingDefaults | null | undefined;
    refetch: () => Promise<any>;
    isLoading: boolean;
    errorMessage: string | null | undefined;
} => {
    const {data, loading, error, refetch} = useQuery<GetBillingDefaultsQuery, Record<any, any>>(
        GET_BILLING_DEFAULTS,
        {
            fetchPolicy: 'cache-and-network',
            skip: shouldSkip,
        }
    );

    const billingDefaults = data ? data.billingDefaults : null;

    return {
        billingDefaults,
        refetch,
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
